// TODO: De-Barrel this file and move icons and redirectly use lucide-react

import type { LucideIcon } from 'lucide-react';

import {
  AlertTriangle,
  ArrowRight,
  BarChart2,
  BookCheck,
  CalendarIcon,
  Check,
  CheckCircle,
  CheckCircle2,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Circle,
  Code,
  Copy,
  CreditCard,
  DollarSign,
  ExternalLink,
  File,
  FileSignature,
  FileSymlink,
  FileText,
  Gift,
  HelpCircle,
  Image,
  ImageUp,
  Import,
  Laptop,
  Linkedin,
  Loader2,
  LucideProps,
  Mail,
  Moon,
  MoreVertical,
  NotebookPen,
  PanelRightClose,
  Pizza,
  Plus,
  Redo,
  RefreshCw,
  Save,
  Settings,
  Sparkles,
  Star,
  SunMedium,
  Trash,
  Twitter,
  Undo,
  Upload,
  User,
  Users,
  Video,
  WalletCards,
  X,
  XCircle
} from 'lucide-react';

import { cn } from '@/lib/utils';

// @ts-expect-error defaultProps in LucideIcon is not typed (icons.tsx)
export type Icon = NonNullable<LucideIcon['defaultProps']>;

export type PickIcons<T extends keyof typeof Icons> = keyof Pick<
  typeof Icons,
  T
>;

export const Icons = {
  draft: NotebookPen,
  publish: BookCheck,
  save: Save,
  checkCircleBig: CheckCircle,
  refresh: RefreshCw,
  sparkles: Sparkles,
  copy: Copy,
  externalLink: ExternalLink,
  stats: BarChart2,
  undo: Undo,
  redo: Redo,
  imageUpload: ImageUp,
  video: Video,
  circle: Circle,
  code: Code,
  close: X,
  spinner: Loader2,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  trash: Trash,
  post: FileText,
  fileEdit: FileSignature,
  fileExternal: FileSymlink,
  page: File,
  media: Image,
  settings: Settings,
  billing: CreditCard,
  ellipsis: MoreVertical,
  add: Plus,
  warning: AlertTriangle,
  user: User,
  arrowRight: ArrowRight,
  help: HelpCircle,
  pizza: Pizza,
  sun: SunMedium,
  moon: Moon,
  laptop: Laptop,
  twitter: Twitter,
  linkedIn: Linkedin,
  mail: Mail,
  check: Check,
  checkCircle: CheckCircle2,
  xCircle: XCircle,
  money: DollarSign,
  users: Users,
  walletCards: WalletCards,
  menu: PanelRightClose,
  gift: Gift,
  upload: Upload,
  calendar: CalendarIcon,
  star: Star,
  chevronDown: ChevronDown,
  import: Import,
  gitHub: ({ ...props }: LucideProps) => (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="github"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 496 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3 .3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5 .3-6.2 2.3zm44.2-1.7c-2.9 .7-4.9 2.6-4.6 4.9 .3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3 .7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3 .3 2.9 2.3 3.9 1.6 1 3.6 .7 4.3-.7 .7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3 .7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3 .7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"
      ></path>
    </svg>
  ),
  logo: ({ className, ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      version="1.1"
      width="640"
      height="640"
      viewBox="0 0 640 640"
      xmlSpace="preserve"
      data-icon="logo"
      {...props}
      className={cn('h-7 w-7', className)}
    >
      <desc>Created with Fabric.js 5.3.0</desc>
      <defs></defs>
      <g
        transform="matrix(6.0970381793 0 0 6.1202185792 467.6156274588 319.8500464964)"
        id="fZedgbkQLWk20UMDhbrCe"
      >
        <linearGradient
          id="SVGID_565"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1 0 0 1 -27.5192394268 -36.0754986686)"
          x1="-0.49999999999998224"
          y1="36.0754986685509"
          x2="55.53847885366487"
          y2="36.0754986685509"
        >
          <stop offset="0%" style={{ stopColor: '#2196F3', stopOpacity: 1 }} />
          <stop
            offset="48.91034581268474%"
            style={{ stopColor: '#007BD5', stopOpacity: 1 }}
          />
          <stop
            offset="100%"
            style={{ stopColor: '#006B8D', stopOpacity: 1 }}
          />
        </linearGradient>
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'url(#SVGID_565)',
            fillRule: 'nonzero',
            opacity: 1
          }}
          vectorEffect="non-scaling-stroke"
          transform=" translate(0, 0)"
          d="M -17.81924 34.2245 C -20.71924 37.8245 -26.51924 35.8245 -26.51924 31.2245 L -27.51924 -36.0755 L 17.680760000000003 -36.0755 C 25.880760000000002 -36.0755 30.480760000000004 -26.575499999999998 25.380760000000002 -20.1755 z"
          strokeLinecap="round"
        />
      </g>
      <g
        transform="matrix(6.0970381793 0 0 6.1202185792 170.4552610874 320.1499535036)"
        id="4DKmhqcPEv1XF0vI91NFv"
      >
        <linearGradient
          id="SVGID_540"
          gradientUnits="userSpaceOnUse"
          gradientTransform="matrix(1 0 0 1 -27.2192388537 -36.0754973371)"
          x1="-0.5000000000000142"
          y1="36.07549866855089"
          x2="54.43847885366492"
          y2="36.07549866855089"
        >
          <stop offset="0%" style={{ stopColor: '#1BFFFF', stopOpacity: 1 }} />
          <stop
            offset="49.363469686882816%"
            style={{ stopColor: '#58CFFF', stopOpacity: 1 }}
          />
          <stop
            offset="100%"
            style={{ stopColor: '#00BCF7', stopOpacity: 1 }}
          />
        </linearGradient>
        <path
          style={{
            stroke: 'none',
            strokeWidth: 1,
            strokeDasharray: 'none',
            strokeLinecap: 'butt',
            strokeDashoffset: 0,
            strokeLinejoin: 'miter',
            strokeMiterlimit: 4,
            fill: 'url(#SVGID_540)',
            fillRule: 'nonzero',
            opacity: 1
          }}
          vectorEffect="non-scaling-stroke"
          transform=" translate(-5.732e-7, -0.0000013314)"
          d="M 18.11924 -34.2245 C 21.01924 -37.8245 26.81924 -35.8245 26.81924 -31.2245 L 27.21924 36.0755 L -17.380760000000002 36.0755 C -25.58076 36.0755 -30.180760000000003 26.575499999999998 -25.08076 20.1755 z"
          strokeLinecap="round"
        />
      </g>
    </svg>
  ),
  google: ({ ...props }: LucideProps) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 488 512"
      {...props}
    >
      <path
        fill="currentColor"
        d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
      />
    </svg>
  ),
  cloud: ({ ...props }: LucideProps) => {
    return (
      <svg viewBox="0 0 128 128" {...props}>
        <path
          fill="#ea4535"
          d="M80.6 40.3h.4l-.2-.2 14-14v-.3c-11.8-10.4-28.1-14-43.2-9.5C36.5 20.8 24.9 32.8 20.7 48c.2-.1.5-.2.8-.2 5.2-3.4 11.4-5.4 17.9-5.4 2.2 0 4.3.2 6.4.6.1-.1.2-.1.3-.1 9-9.9 24.2-11.1 34.6-2.6h-.1z"
        ></path>
        <path
          fill="#557ebf"
          d="M108.1 47.8c-2.3-8.5-7.1-16.2-13.8-22.1L80 39.9c6 4.9 9.5 12.3 9.3 20v2.5c16.9 0 16.9 25.2 0 25.2H63.9v20h-.1l.1.2h25.4c14.6.1 27.5-9.3 31.8-23.1 4.3-13.8-1-28.8-13-36.9z"
        ></path>
        <path
          fill="#36a852"
          d="M39 107.9h26.3V87.7H39c-1.9 0-3.7-.4-5.4-1.1l-15.2 14.6v.2c6 4.3 13.2 6.6 20.7 6.6z"
        ></path>
        <path
          fill="#f9bc15"
          d="M40.2 41.9c-14.9.1-28.1 9.3-32.9 22.8-4.8 13.6 0 28.5 11.8 37.3l15.6-14.9c-8.6-3.7-10.6-14.5-4-20.8 6.6-6.4 17.8-4.4 21.7 3.8L68 55.2C61.4 46.9 51.1 42 40.2 42.1z"
        ></path>
      </svg>
    );
  },
  azure: ({ ...props }: LucideProps) => {
    return (
      <svg viewBox="0 0 128 128" {...props}>
        <defs>
          <linearGradient
            id="azure-original-a"
            x1="60.919"
            y1="9.602"
            x2="18.667"
            y2="134.423"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#114A8B"></stop>
            <stop offset="1" stopColor="#0669BC"></stop>
          </linearGradient>
          <linearGradient
            id="azure-original-b"
            x1="74.117"
            y1="67.772"
            x2="64.344"
            y2="71.076"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopOpacity=".3"></stop>
            <stop offset=".071" stopOpacity=".2"></stop>
            <stop offset=".321" stopOpacity=".1"></stop>
            <stop offset=".623" stopOpacity=".05"></stop>
            <stop offset="1" stopOpacity="0"></stop>
          </linearGradient>
          <linearGradient
            id="azure-original-c"
            x1="68.742"
            y1="5.961"
            x2="115.122"
            y2="129.525"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#3CCBF4"></stop>
            <stop offset="1" stopColor="#2892DF"></stop>
          </linearGradient>
        </defs>
        <path
          d="M46.09.002h40.685L44.541 125.137a6.485 6.485 0 01-6.146 4.413H6.733a6.482 6.482 0 01-5.262-2.699 6.474 6.474 0 01-.876-5.848L39.944 4.414A6.488 6.488 0 0146.09 0z"
          fill="url(#azure-original-a)"
          transform="translate(.587 4.468) scale(.91904)"
        ></path>
        <path
          d="M97.28 81.607H37.987a2.743 2.743 0 00-1.874 4.751l38.1 35.562a5.991 5.991 0 004.087 1.61h33.574z"
          fill="#0078d4"
        ></path>
        <path
          d="M46.09.002A6.434 6.434 0 0039.93 4.5L.644 120.897a6.469 6.469 0 006.106 8.653h32.48a6.942 6.942 0 005.328-4.531l7.834-23.089 27.985 26.101a6.618 6.618 0 004.165 1.519h36.396l-15.963-45.616-46.533.011L86.922.002z"
          fill="url(#azure-original-b)"
          transform="translate(.587 4.468) scale(.91904)"
        ></path>
        <path
          d="M98.055 4.408A6.476 6.476 0 0091.917.002H46.575a6.478 6.478 0 016.137 4.406l39.35 116.594a6.476 6.476 0 01-6.137 8.55h45.344a6.48 6.48 0 006.136-8.55z"
          fill="url(#azure-original-c)"
          transform="translate(.587 4.468) scale(.91904)"
        ></path>
      </svg>
    );
  },
  docker: ({ ...props }: LucideProps) => {
    return (
      <svg viewBox="0 0 128 128" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#3A4D54"
          d="M73.8 50.8h11.3v11.5h5.7c2.6 0 5.3-.5 7.8-1.3 1.2-.4 2.6-1 3.8-1.7-1.6-2.1-2.4-4.7-2.6-7.3-.3-3.5.4-8.1 2.8-10.8l1.2-1.4 1.4 1.1c3.6 2.9 6.5 6.8 7.1 11.4 4.3-1.3 9.3-1 13.1 1.2l1.5.9-.8 1.6c-3.2 6.2-9.9 8.2-16.4 7.8-9.8 24.3-31 35.8-56.8 35.8-13.3 0-25.5-5-32.5-16.8l-.1-.2-1-2.1c-2.4-5.2-3.1-10.9-2.6-16.6l.2-1.7h9.6V50.8h11.3V39.6h22.5V28.3h13.5v22.5z"
        ></path>
        <path
          fill="#00AADA"
          d="M110.4 55.1c.8-5.9-3.6-10.5-6.4-12.7-3.1 3.6-3.6 13.2 1.3 17.2-2.8 2.4-8.5 4.7-14.5 4.7H18.6c-.6 6.2.5 11.9 3 16.8l.8 1.5c.5.9 1.1 1.7 1.7 2.6 3 .2 5.7.3 8.2.2 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5 1.1-8.3 1.3h-.6c-1.3.1-2.7.1-4.2.1-1.6 0-3.1 0-4.9-.1 6 6.8 15.4 10.8 27.2 10.8 25 0 46.2-11.1 55.5-35.9 6.7.7 13.1-1 16-6.7-4.5-2.7-10.5-1.8-13.9-.1z"
        ></path>
        <path
          fill="#28B8EB"
          d="M110.4 55.1c.8-5.9-3.6-10.5-6.4-12.7-3.1 3.6-3.6 13.2 1.3 17.2-2.8 2.4-8.5 4.7-14.5 4.7h-68c-.3 9.5 3.2 16.7 9.5 21 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.5 1.4l-.1-.1c8.5 4.4 20.8 4.3 35-1.1 15.8-6.1 30.6-17.7 40.9-30.9-.2.1-.4.1-.5.2z"
        ></path>
        <path
          fill="#028BB8"
          d="M18.7 71.8c.4 3.3 1.4 6.4 2.9 9.3l.8 1.5c.5.9 1.1 1.7 1.7 2.6 3 .2 5.7.3 8.2.2 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.5 1.4h-.4c-1.3.1-2.7.1-4.1.1-1.6 0-3.2 0-4.9-.1 6 6.8 15.5 10.8 27.3 10.8 21.4 0 40-8.1 50.8-26H18.7v-.1z"
        ></path>
        <path
          fill="#019BC6"
          d="M23.5 71.8c1.3 5.8 4.3 10.4 8.8 13.5 4.9-.1 8.9-.7 12-1.7.5-.2.9.1 1.1.5.2.5-.1.9-.5 1.1-.4.1-.8.3-1.3.4-2.4.7-5.2 1.2-8.6 1.4 8.5 4.4 20.8 4.3 34.9-1.1 8.5-3.3 16.8-8.2 24.2-14.1H23.5z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#00ACD3"
          d="M28.4 52.7h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm3-12h9.8v9.8h-9.8v-9.8zm.9.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#23C2EE"
          d="M39.6 52.7h9.8v9.8h-9.8v-9.8zm.9.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#00ACD3"
          d="M50.9 52.7h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#23C2EE"
          d="M50.9 41.5h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm3.1 10.4H72v9.8h-9.8v-9.8zm.8.8h.8v8.1H63v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#00ACD3"
          d="M62.2 41.5H72v9.8h-9.8v-9.8zm.8.8h.8v8.1H63v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#23C2EE"
          d="M62.2 30.2H72V40h-9.8v-9.8zm.8.8h.8v8.1H63V31zm1.5 0h.8v8.1h-.8V31zm1.4 0h.8v8.1h-.8V31zm1.5 0h.8v8.1h-.8V31zm1.5 0h.8v8.1h-.8V31zm1.5 0h.8v8.1h-.8V31z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#00ACD3"
          d="M73.5 52.7h9.8v9.8h-9.8v-9.8zm.8.8h.8v8.1h-.8v-8.1zm1.4 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1zm1.5 0h.8v8.1h-.8v-8.1z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#D4EEF1"
          d="M48.8 78.3c1.5 0 2.7 1.2 2.7 2.7 0 1.5-1.2 2.7-2.7 2.7-1.5 0-2.7-1.2-2.7-2.7 0-1.5 1.2-2.7 2.7-2.7"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#3A4D54"
          d="M48.8 79.1c.2 0 .5 0 .7.1-.2.1-.4.4-.4.7 0 .4.4.8.8.8.3 0 .6-.2.7-.4.1.2.1.5.1.7 0 1.1-.9 1.9-1.9 1.9-1.1 0-1.9-.9-1.9-1.9 0-1 .8-1.9 1.9-1.9M1.1 72.8h125.4c-2.7-.7-8.6-1.6-7.7-5.2-5 5.7-16.9 4-20 1.2-3.4 4.9-23 3-24.3-.8-4.2 5-17.3 5-21.5 0-1.4 3.8-21 5.7-24.3.8-3 2.8-15 4.5-20-1.2 1.1 3.5-4.9 4.5-7.6 5.2"
        ></path>
        <path
          fill="#BFDBE0"
          d="M56 97.8c-6.7-3.2-10.3-7.5-12.4-12.2-2.5.7-5.5 1.2-8.9 1.4-1.3.1-2.7.1-4.1.1-1.7 0-3.4 0-5.2-.1 6 6 13.6 10.7 27.5 10.8H56z"
        ></path>
        <path
          fill="#D4EEF1"
          d="M46.1 89.9c-.9-1.3-1.8-2.8-2.5-4.3-2.5.7-5.5 1.2-8.9 1.4 2.3 1.2 5.7 2.4 11.4 2.9z"
        ></path>
      </svg>
    );
  },
  go: ({ ...props }: LucideProps) => {
    return (
      <svg viewBox="0 0 128 128" {...props}>
        <defs>
          <path id="go-original-a" d="M18.8 1h90.5v126H18.8z"></path>
        </defs>
        <clipPath id="go-original-b">
          <use xlinkHref="#go-original-a" overflow="visible"></use>
        </clipPath>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#F6D2A2"
          d="M21.1 68.7c.2 3.5 3.7 1.9 5.3.8 1.5-1.1 2-.2 2.1-2.3.1-1.4.2-2.7.2-4.1-2.3-.2-4.8.3-6.7 1.7-.9.7-2.8 3-.9 3.9"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M23 71.2c-.7 0-2-.3-2.2-2.3-.6-.4-.8-.9-.8-1.2-.1-1.2 1.2-2.6 1.9-3.1 1.6-1.2 3.7-1.8 5.9-1.8h1.3v.3c.1 1.1 0 2.2-.1 3.2 0 .3 0 .6-.1.9-.1 1.5-.4 1.7-1.1 2-.3.1-.6.2-1.1.6-.5.3-2.2 1.4-3.7 1.4zm4.8-7.8c-2.1 0-4 .6-5.5 1.7-.7.5-1.7 1.7-1.6 2.5 0 .3.2.6.6.8l.2.1v.2c.1 1.6.9 1.8 1.5 1.8 1 0 2.4-.7 3.3-1.3.6-.4 1-.5 1.3-.6.5-.2.6-.2.7-1.4 0-.3 0-.6.1-.9.1-.9.1-1.9.1-2.8-.3-.1-.5-.1-.7-.1z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#C6B198"
          d="M21.1 68.7c.5-.2 1.1-.3 1.4-.8"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M21.1 69c-.1 0-.3-.1-.3-.2-.1-.2 0-.4.2-.4.1 0 .2-.1.2-.1.4-.2.8-.3 1-.6.1-.1.3-.2.5-.1.1.1.2.3.1.5-.4.5-.9.7-1.3.8l-.2.1h-.2z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#6AD7E5"
          d="M29.3 26.4c-13.6-3.8-3.5-21.1 7.4-14l-7.4 14z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M29.5 26.8l-.3-.1c-7-2-6.9-7-6.7-8.5.5-3.8 4.1-7.8 8.9-7.8 1.9 0 3.7.6 5.5 1.8l.3.2-7.7 14.4zm1.9-15.7c-4.5 0-7.8 3.7-8.3 7.2-.5 3.6 1.7 6.4 6 7.7l7.1-13.5c-1.5-.9-3.1-1.4-4.8-1.4z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#6AD7E5"
          d="M89.6 11.1c10.7-7.5 20.5 9.5 8 13.8l-8-13.8z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M97.5 25.3L89.2 11l.3-.2c1.9-1.3 3.8-2 5.7-2 4.6 0 7.9 3.8 8.6 7.5.3 1.5.6 6.6-6 8.8l-.3.2zm-7.4-14l7.7 13.3c3.9-1.4 5.9-4.4 5.3-8-.6-3.4-3.7-6.9-7.9-6.9-1.7-.1-3.4.4-5.1 1.6z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#F6D2A2"
          d="M92 112.3c2.7 1.7 7.7 6.8 3.6 9.3-3.9 3.6-6.1-4-9.6-5 1.5-2 3.4-3.9 6-4.3"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M93.5 122.9c-1.6 0-3-1.6-4.2-3.1-1.1-1.2-2.2-2.5-3.4-2.9l-.5-.1.3-.4c1.2-1.7 3.2-3.9 6.2-4.4h.1l.1.1c1.7 1.1 5.4 4.2 5.3 7.1 0 1.1-.6 2-1.7 2.7-.7.7-1.4 1-2.2 1zm-7-6.5c1.2.5 2.2 1.8 3.2 2.9 1.2 1.5 2.4 2.8 3.7 2.8.6 0 1.2-.3 1.8-.9h.1c.9-.6 1.4-1.3 1.4-2.2 0-2.3-2.9-5.2-4.9-6.5-1.8.5-3.6 1.7-5.3 3.9zm9.1 5.5c-.1 0-.2-.1-.3-.2-.2-.4-.4-.9-.5-1.3-.3-.8-.6-1.6-1.2-2.2-.1-.1-.1-.3 0-.5.1-.1.3-.1.5 0 .7.7 1.1 1.6 1.4 2.5l.5 1.2c.1.2 0 .4-.1.5h-.3z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#F6D2A2"
          d="M43.2 118.1c-3.2.5-5 3.4-7.7 4.9-2.5 1.5-3.5-.5-3.7-.9-.4-.2-.4.2-1-.4-2.3-3.7 2.4-6.4 4.9-8.2 3.5-.8 5.7 2.2 7.5 4.6"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M33.8 123.8c-1.3 0-2-1.1-2.2-1.5h-.1c-.3 0-.5-.1-.9-.5v-.1c-2.2-3.5 1.6-6.2 4.1-8l.9-.6h.2c.4-.1.7-.1 1.1-.1 3 0 4.9 2.6 6.5 4.7l.5.7-.6.1c-1.9.3-3.3 1.5-4.7 2.7-.9.8-1.8 1.5-2.8 2.1-.8.3-1.4.5-2 .5zm-2.2-2.1c.1 0 .2 0 .4.1h.1l.1.1c.2.3.7 1.2 1.7 1.2.5 0 1-.2 1.5-.5 1-.5 1.9-1.3 2.7-2 1.3-1.1 2.7-2.3 4.5-2.8-1.5-2-3.3-4.2-5.8-4.2-.3 0-.6 0-.9.1l-.8.6c-2.6 1.8-5.8 4.1-3.9 7.1.1.2.2.3.4.3zm.2.7c-.2 0-.4-.2-.3-.4.1-1 .6-1.7 1.1-2.5.3-.4.5-.8.7-1.2.1-.2.3-.2.4-.2.2.1.2.3.2.4-.2.5-.5.9-.8 1.3-.5.7-.9 1.3-1 2.1 0 .4-.1.5-.3.5z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.9 21.7c-1.8-.9-3.1-2.2-2-4.3 1-1.9 2.9-1.7 4.7-.8l-2.7 5.1zm64.9-1.8c1.8-.9 3.1-2.2 2-4.3-1-1.9-2.9-1.7-4.7-.8l2.7 5.1z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#F6D2A2"
          d="M107.1 68.2c-.2 3.5-3.7 1.9-5.3.8-1.5-1.1-2-.2-2.1-2.3-.1-1.4-.2-2.7-.2-4.1 2.3-.2 4.8.3 6.7 1.7 1 .8 2.8 3 .9 3.9"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M105.3 70.7c-1.5 0-3.2-1.1-3.7-1.4-.5-.3-.8-.5-1.1-.6-.8-.3-1-.5-1.1-2 0-.3 0-.6-.1-.9-.1-1-.2-2.1-.1-3.2v-.3h1.3c2.2 0 4.3.6 5.9 1.8.7.5 2 1.9 1.9 3.1 0 .4-.2.9-.8 1.2-.2 2-1.5 2.3-2.2 2.3zM99.8 63c0 .9 0 1.9.1 2.8 0 .3 0 .6.1.9.1 1.2.2 1.2.7 1.4.3.1.7.3 1.3.6.9.6 2.3 1.3 3.3 1.3.6 0 1.4-.2 1.5-1.8V68l.2-.1c.4-.2.6-.4.6-.8.1-.8-.9-2-1.6-2.5-1.5-1.1-3.5-1.7-5.5-1.7-.2.1-.4.1-.7.1z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#C6B198"
          d="M107.1 68.2c-.5-.2-1.1-.3-1.4-.8"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M107.1 68.6h-.1l-.2-.1c-.5-.2-1-.3-1.3-.8-.1-.1-.1-.4.1-.5.1-.1.4-.1.5.1.2.3.6.4 1 .6.1 0 .2.1.2.1.2.1.3.3.2.4-.1.1-.3.2-.4.2z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#6AD7E5"
          d="M62.8 4c13.6 0 26.3 1.9 33 15 6 14.6 3.8 30.4 4.8 45.9.8 13.3 2.5 28.6-3.6 40.9-6.5 12.9-22.7 16.2-36 15.7-10.5-.4-23.1-3.8-29.1-13.4-6.9-11.2-3.7-27.9-3.2-40.4.6-14.8-4-29.7.9-44.1C34.5 8.5 48.1 5.1 62.8 4"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M63.3 121.9h-2.5c-4.1-.1-10.3-.8-16.4-3.3-5.9-2.4-10.2-5.8-13-10.3-5.6-9.1-4.6-21.6-3.7-32.7.2-2.8.4-5.4.5-7.9.2-5.2-.2-10.6-.7-15.7-.8-9.4-1.6-19.1 1.5-28.5 2.4-7 6.7-12 13.2-15.2 5.1-2.5 11.4-3.9 20.4-4.6C76 3.6 89.3 5.5 96 18.8c4.4 10.7 4.4 22.2 4.5 33.3 0 4.2 0 8.5.3 12.7.1 1.3.2 2.6.2 3.9.8 12.2 1.7 26-3.9 37.2-2.8 5.7-7.7 9.9-14.4 12.6-5.4 2.2-12.2 3.4-19.4 3.4zM62.8 4.3c-14.1 1.1-27.9 4.2-33 19.4-3.1 9.3-2.3 18.9-1.5 28.2.4 5.2.9 10.5.7 15.8-.1 2.5-.3 5.1-.5 7.9-.9 11-1.9 23.4 3.6 32.3 2.3 3.7 9.7 12.5 28.8 13.2h2.5c22.1 0 30.3-9.8 33.3-15.6 5.5-11 4.6-24.8 3.9-36.9-.1-1.3-.2-2.6-.2-3.9-.2-4.2-.3-8.5-.3-12.7-.1-11-.1-22.5-4.4-33.1C92.7 13 88.2 9 82 6.7c-6.4-2.1-13.6-2.4-19.2-2.4z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#fff"
          d="M65.2 22.2c2.4 14.2 25.6 10.4 22.3-3.9-3-12.8-23.1-9.2-22.3 3.9"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M76.2 31.5c-4.5 0-10.2-2.4-11.4-9.2-.2-3.2.8-6.1 2.9-8.3 2.3-2.5 5.8-3.9 9.4-3.9 4.2 0 9.2 2.2 10.6 8.3.8 3.4.2 6.4-1.7 8.8-2.1 2.6-5.8 4.3-9.8 4.3zm-10.7-9.3c.5 2.8 1.8 5 3.9 6.6 1.8 1.4 4.3 2.1 6.8 2.1 3.7 0 7.3-1.6 9.3-4.1 1.8-2.2 2.3-5.1 1.6-8.3-1.3-5.7-6-7.7-10-7.7-3.4 0-6.7 1.4-8.9 3.7-1.9 2-2.9 4.7-2.7 7.7z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#fff"
          d="M37.5 24.5c3.2 12.3 22.9 9.2 22.2-3.2-.9-14.8-25.3-12-22.2 3.2"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M48 32.7c-4.3 0-9.3-2.1-10.9-8.1-.7-3.5 0-6.7 2-9.1 2.2-2.7 5.8-4.3 9.7-4.3 5.2 0 10.7 3.1 11.1 10.1.2 2.9-.7 5.5-2.7 7.6-2.1 2.3-5.6 3.8-9.2 3.8zm.8-20.8c-3.7 0-7.1 1.5-9.2 4-1.9 2.3-2.5 5.2-1.8 8.5C39.2 30 44 32 48 32c3.4 0 6.7-1.3 8.8-3.6 1.8-1.9 2.7-4.4 2.5-7.1-.2-4.3-3.1-9.4-10.5-9.4z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#fff"
          d="M68 39.2c0 1.8.4 3.9.1 5.9-.5.9-1.4 1-2.2 1.3-1.1-.2-2-.9-2.5-1.9-.3-2.2.1-4.4.2-6.6l4.4 1.3z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M65.9 46.8c-1.3-.2-2.3-1-2.8-2.1-.2-1.6-.1-3.1 0-4.6.1-.7.1-1.4.1-2.1v-.4l5.1 1.6v.2c0 .6.1 1.2.1 1.9.1 1.3.2 2.7 0 4v.1c-.4.8-1.1 1-1.8 1.3-.2-.1-.4 0-.7.1zm-2.2-2.4c.4.9 1.2 1.5 2.1 1.7.2-.1.4-.1.5-.2.6-.2 1.1-.4 1.4-.9.2-1.2.1-2.5 0-3.8 0-.6-.1-1.2-.1-1.7l-3.8-1.2c0 .6-.1 1.2-.1 1.7-.1 1.6-.2 3 0 4.4z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M46.3 22.5c0 2-1.5 3.6-3.3 3.6-1.8 0-3.3-1.6-3.3-3.6s1.5-3.6 3.3-3.6c1.8 0 3.3 1.6 3.3 3.6"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#fff"
          d="M45.2 23.3c0 .5-.4.9-.8.9s-.8-.4-.8-.9.4-.9.8-.9c.5 0 .8.4.8.9"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M74.2 21.6c0 2-1.5 3.6-3.3 3.6-1.8 0-3.3-1.6-3.3-3.6s1.5-3.6 3.3-3.6c1.8 0 3.3 1.6 3.3 3.6"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#fff"
          d="M73.2 22.4c0 .5-.3.9-.8.9-.4 0-.8-.4-.8-.9s.3-.9.8-.9c.4 0 .8.4.8.9M58.4 39c-1.5 3.5.8 10.6 4.8 5.4-.3-2.2.1-4.4.2-6.6l-5 1.2z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          d="M60.5 46.6c-.7 0-1.4-.4-1.9-1.2-1.1-1.6-1.3-4.6-.5-6.5l.1-.2 5.5-1.4v.4l-.1 2.2c-.1 1.5-.2 2.9 0 4.4v.1l-.1.1c-1 1.4-2 2.1-3 2.1zm-1.8-7.3c-.6 1.7-.4 4.4.5 5.7.4.6.8.9 1.3.9.7 0 1.5-.6 2.3-1.6-.2-1.5-.1-3 .1-4.4l.1-1.7-4.3 1.1z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          fill="#F6D2A2"
          d="M58.9 32.2c-2.7.2-4.9 3.5-3.5 6 1.9 3.4 6-.3 8.6 0 3 .1 5.4 3.2 7.8.6 2.7-2.9-1.2-5.7-4.1-7l-8.8.4z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fill="#231F20"
          d="M69.7 40.2c-.9 0-1.8-.4-2.7-.8-.9-.4-1.9-.8-3-.8h-.3c-.8 0-1.7.3-2.7.7-1.1.4-2.2.7-3.2.7-1.2 0-2.1-.5-2.7-1.6-.7-1.2-.6-2.6.1-3.9.8-1.5 2.2-2.4 3.7-2.6l8.9-.4h.1c2.2.9 4.7 2.6 5.2 4.6.2 1-.1 2-.9 2.9-.8.9-1.6 1.2-2.5 1.2zM64.1 38c1.1 0 2.2.5 3.2.9.9.4 1.7.7 2.5.7.7 0 1.3-.3 1.9-.9.7-.7.9-1.5.8-2.3-.4-1.7-2.8-3.3-4.7-4.1l-8.7.4c-1.3.1-2.5 1-3.2 2.2-.6 1.1-.6 2.3-.1 3.3.5.9 1.1 1.3 2.1 1.3.9 0 1.9-.4 2.9-.7 1.1-.4 2-.7 3-.7 0-.2.1-.2.3-.1z"
          clipPath="url(#go-original-b)"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M58.6 32.1c-.2-4.7 8.8-5.3 9.8-1.4 1.1 4-9.4 4.9-9.8 1.4"
          clipPath="url(#go-original-b)"
        ></path>
      </svg>
    );
  },
  python: ({ ...props }: LucideProps) => (
    <svg viewBox="0 0 128 128" {...props}>
      <linearGradient
        id="python-original-a"
        gradientUnits="userSpaceOnUse"
        x1="70.252"
        y1="1237.476"
        x2="170.659"
        y2="1151.089"
        gradientTransform="matrix(.563 0 0 -.568 -29.215 707.817)"
      >
        <stop offset="0" stopColor="#5A9FD4"></stop>
        <stop offset="1" stopColor="#306998"></stop>
      </linearGradient>
      <linearGradient
        id="python-original-b"
        gradientUnits="userSpaceOnUse"
        x1="209.474"
        y1="1098.811"
        x2="173.62"
        y2="1149.537"
        gradientTransform="matrix(.563 0 0 -.568 -29.215 707.817)"
      >
        <stop offset="0" stopColor="#FFD43B"></stop>
        <stop offset="1" stopColor="#FFE873"></stop>
      </linearGradient>
      <path
        fill="url(#python-original-a)"
        d="M63.391 1.988c-4.222.02-8.252.379-11.8 1.007-10.45 1.846-12.346 5.71-12.346 12.837v9.411h24.693v3.137H29.977c-7.176 0-13.46 4.313-15.426 12.521-2.268 9.405-2.368 15.275 0 25.096 1.755 7.311 5.947 12.519 13.124 12.519h8.491V67.234c0-8.151 7.051-15.34 15.426-15.34h24.665c6.866 0 12.346-5.654 12.346-12.548V15.833c0-6.693-5.646-11.72-12.346-12.837-4.244-.706-8.645-1.027-12.866-1.008zM50.037 9.557c2.55 0 4.634 2.117 4.634 4.721 0 2.593-2.083 4.69-4.634 4.69-2.56 0-4.633-2.097-4.633-4.69-.001-2.604 2.073-4.721 4.633-4.721z"
        transform="translate(0 10.26)"
      ></path>
      <path
        fill="url(#python-original-b)"
        d="M91.682 28.38v10.966c0 8.5-7.208 15.655-15.426 15.655H51.591c-6.756 0-12.346 5.783-12.346 12.549v23.515c0 6.691 5.818 10.628 12.346 12.547 7.816 2.297 15.312 2.713 24.665 0 6.216-1.801 12.346-5.423 12.346-12.547v-9.412H63.938v-3.138h37.012c7.176 0 9.852-5.005 12.348-12.519 2.578-7.735 2.467-15.174 0-25.096-1.774-7.145-5.161-12.521-12.348-12.521h-9.268zM77.809 87.927c2.561 0 4.634 2.097 4.634 4.692 0 2.602-2.074 4.719-4.634 4.719-2.55 0-4.633-2.117-4.633-4.719 0-2.595 2.083-4.692 4.633-4.692z"
        transform="translate(0 10.26)"
      ></path>
      <radialGradient
        id="python-original-c"
        cx="1825.678"
        cy="444.45"
        r="26.743"
        gradientTransform="matrix(0 -.24 -1.055 0 532.979 557.576)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#B8B8B8" stopOpacity=".498"></stop>
        <stop offset="1" stopColor="#7F7F7F" stopOpacity="0"></stop>
      </radialGradient>
      <path
        opacity=".444"
        fill="url(#python-original-c)"
        d="M97.309 119.597c0 3.543-14.816 6.416-33.091 6.416-18.276 0-33.092-2.873-33.092-6.416 0-3.544 14.815-6.417 33.092-6.417 18.275 0 33.091 2.872 33.091 6.417z"
      ></path>
    </svg>
  ),
  kotlin: ({ ...props }: LucideProps) => (
    <svg viewBox="0 0 128 128" {...props}>
      <linearGradient
        id="kotlin-original-a"
        gradientUnits="userSpaceOnUse"
        x1="-11.899"
        y1="48.694"
        x2="40.299"
        y2="-8.322"
      >
        <stop offset="0" stopColor="#1c93c1"></stop>
        <stop offset=".163" stopColor="#2391c0"></stop>
        <stop offset=".404" stopColor="#378bbe"></stop>
        <stop offset=".696" stopColor="#587eb9"></stop>
        <stop offset=".995" stopColor="#7f6cb1"></stop>
      </linearGradient>
      <path fill="url(#kotlin-original-a)" d="M0 0h65.4L0 64.4z"></path>
      <linearGradient
        id="kotlin-original-b"
        gradientUnits="userSpaceOnUse"
        x1="43.553"
        y1="149.174"
        x2="95.988"
        y2="94.876"
      >
        <stop offset="0" stopColor="#1c93c1"></stop>
        <stop offset=".216" stopColor="#2d8ebf"></stop>
        <stop offset=".64" stopColor="#587eb9"></stop>
        <stop offset=".995" stopColor="#7f6cb1"></stop>
      </linearGradient>
      <path fill="url(#kotlin-original-b)" d="M128 128L64.6 62.6 0 128z"></path>
      <linearGradient
        id="kotlin-original-c"
        gradientUnits="userSpaceOnUse"
        x1="3.24"
        y1="95.249"
        x2="92.481"
        y2="2.116"
      >
        <stop offset="0" stopColor="#c757a7"></stop>
        <stop offset=".046" stopColor="#ca5a9e"></stop>
        <stop offset=".241" stopColor="#d66779"></stop>
        <stop offset=".428" stopColor="#e17357"></stop>
        <stop offset=".6" stopColor="#e97c3a"></stop>
        <stop offset=".756" stopColor="#ef8324"></stop>
        <stop offset=".888" stopColor="#f28817"></stop>
        <stop offset=".982" stopColor="#f48912"></stop>
      </linearGradient>
      <path fill="url(#kotlin-original-c)" d="M0 128L128 0H64.6L0 63.7z"></path>
    </svg>
  ),
  java: ({ ...props }: LucideProps) => (
    <svg viewBox="0 0 128 128" {...props}>
      <path
        fill="#0074BD"
        d="M47.617 98.12s-4.767 2.774 3.397 3.71c9.892 1.13 14.947.968 25.845-1.092 0 0 2.871 1.795 6.873 3.351-24.439 10.47-55.308-.607-36.115-5.969zm-2.988-13.665s-5.348 3.959 2.823 4.805c10.567 1.091 18.91 1.18 33.354-1.6 0 0 1.993 2.025 5.132 3.131-29.542 8.64-62.446.68-41.309-6.336z"
      ></path>
      <path
        fill="#EA2D2E"
        d="M69.802 61.271c6.025 6.935-1.58 13.17-1.58 13.17s15.289-7.891 8.269-17.777c-6.559-9.215-11.587-13.792 15.635-29.58 0 .001-42.731 10.67-22.324 34.187z"
      ></path>
      <path
        fill="#0074BD"
        d="M102.123 108.229s3.529 2.91-3.888 5.159c-14.102 4.272-58.706 5.56-71.094.171-4.451-1.938 3.899-4.625 6.526-5.192 2.739-.593 4.303-.485 4.303-.485-4.953-3.487-32.013 6.85-13.743 9.815 49.821 8.076 90.817-3.637 77.896-9.468zM49.912 70.294s-22.686 5.389-8.033 7.348c6.188.828 18.518.638 30.011-.326 9.39-.789 18.813-2.474 18.813-2.474s-3.308 1.419-5.704 3.053c-23.042 6.061-67.544 3.238-54.731-2.958 10.832-5.239 19.644-4.643 19.644-4.643zm40.697 22.747c23.421-12.167 12.591-23.86 5.032-22.285-1.848.385-2.677.72-2.677.72s.688-1.079 2-1.543c14.953-5.255 26.451 15.503-4.823 23.725 0-.002.359-.327.468-.617z"
      ></path>
      <path
        fill="#EA2D2E"
        d="M76.491 1.587S89.459 14.563 64.188 34.51c-20.266 16.006-4.621 25.13-.007 35.559-11.831-10.673-20.509-20.07-14.688-28.815C58.041 28.42 81.722 22.195 76.491 1.587z"
      ></path>
      <path
        fill="#0074BD"
        d="M52.214 126.021c22.476 1.437 57-.8 57.817-11.436 0 0-1.571 4.032-18.577 7.231-19.186 3.612-42.854 3.191-56.887.874 0 .001 2.875 2.381 17.647 3.331z"
      ></path>
    </svg>
  ),
  js: ({ ...props }: LucideProps) => (
    <svg viewBox="0 0 128 128" {...props}>
      <path fill="#F0DB4F" d="M1.408 1.408h125.184v125.185H1.408z"></path>
      <path
        fill="#323330"
        d="M116.347 96.736c-.917-5.711-4.641-10.508-15.672-14.981-3.832-1.761-8.104-3.022-9.377-5.926-.452-1.69-.512-2.642-.226-3.665.821-3.32 4.784-4.355 7.925-3.403 2.023.678 3.938 2.237 5.093 4.724 5.402-3.498 5.391-3.475 9.163-5.879-1.381-2.141-2.118-3.129-3.022-4.045-3.249-3.629-7.676-5.498-14.756-5.355l-3.688.477c-3.534.893-6.902 2.748-8.877 5.235-5.926 6.724-4.236 18.492 2.975 23.335 7.104 5.332 17.54 6.545 18.873 11.531 1.297 6.104-4.486 8.08-10.234 7.378-4.236-.881-6.592-3.034-9.139-6.949-4.688 2.713-4.688 2.713-9.508 5.485 1.143 2.499 2.344 3.63 4.26 5.795 9.068 9.198 31.76 8.746 35.83-5.176.165-.478 1.261-3.666.38-8.581zM69.462 58.943H57.753l-.048 30.272c0 6.438.333 12.34-.714 14.149-1.713 3.558-6.152 3.117-8.175 2.427-2.059-1.012-3.106-2.451-4.319-4.485-.333-.584-.583-1.036-.667-1.071l-9.52 5.83c1.583 3.249 3.915 6.069 6.902 7.901 4.462 2.678 10.459 3.499 16.731 2.059 4.082-1.189 7.604-3.652 9.448-7.401 2.666-4.915 2.094-10.864 2.07-17.444.06-10.735.001-21.468.001-32.237z"
      ></path>
    </svg>
  ),
  swift: ({ ...props }: LucideProps) => (
    <svg viewBox="0 0 128 128" {...props}>
      <path
        fill="#f05138"
        d="M126.33 34.06a39.32 39.32 0 00-.79-7.83 28.78 28.78 0 00-2.65-7.58 28.84 28.84 0 00-4.76-6.32 23.42 23.42 0 00-6.62-4.55 27.27 27.27 0 00-7.68-2.53c-2.65-.51-5.56-.51-8.21-.76H30.25a45.46 45.46 0 00-6.09.51 21.82 21.82 0 00-5.82 1.52c-.53.25-1.32.51-1.85.76a33.82 33.82 0 00-5 3.28c-.53.51-1.06.76-1.59 1.26a22.41 22.41 0 00-4.76 6.32 23.61 23.61 0 00-2.65 7.58 78.5 78.5 0 00-.79 7.83v60.39a39.32 39.32 0 00.79 7.83 28.78 28.78 0 002.65 7.58 28.84 28.84 0 004.76 6.32 23.42 23.42 0 006.62 4.55 27.27 27.27 0 007.68 2.53c2.65.51 5.56.51 8.21.76h63.22a45.08 45.08 0 008.21-.76 27.27 27.27 0 007.68-2.53 30.13 30.13 0 006.62-4.55 22.41 22.41 0 004.76-6.32 23.61 23.61 0 002.65-7.58 78.49 78.49 0 00.79-7.83V34.06z"
      ></path>
      <path
        fill="#fefefe"
        d="M85 96.5c-11.11 6.13-26.38 6.76-41.75.47A64.53 64.53 0 0113.84 73a50 50 0 0010.85 6.32c15.87 7.1 31.73 6.61 42.9 0-15.9-11.66-29.4-26.82-39.46-39.2a43.47 43.47 0 01-5.29-6.82c12.16 10.61 31.5 24 38.38 27.79a271.77 271.77 0 01-27-32.34 266.8 266.8 0 0044.47 34.87c.71.38 1.26.7 1.7 1a32.7 32.7 0 001.21-3.51c3.71-12.89-.53-27.54-9.79-39.67C93.25 33.81 106 57.05 100.66 76.51c-.14.53-.29 1-.45 1.55l.19.22c10.59 12.63 7.68 26 6.35 23.5C101 91 90.37 94.33 85 96.5z"
      ></path>
    </svg>
  ),

  ruby: ({ ...props }: LucideProps) => (
    <svg viewBox="0 0 128 128" {...props}>
      <linearGradient
        id="ruby-original-a"
        gradientUnits="userSpaceOnUse"
        x1="157.08"
        y1="2382.05"
        x2="131.682"
        y2="2426.892"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#FB7655"></stop>
        <stop offset="0" stopColor="#FB7655"></stop>
        <stop offset=".41" stopColor="#E42B1E"></stop>
        <stop offset=".99" stopColor="#900"></stop>
        <stop offset="1" stopColor="#900"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-a)"
        d="M97.078 83.214L28.34 124.031l89.003-6.04 6.855-89.745z"
      ></path>
      <linearGradient
        id="ruby-original-b"
        gradientUnits="userSpaceOnUse"
        x1="169.731"
        y1="2419.72"
        x2="136.998"
        y2="2441.685"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#871101"></stop>
        <stop offset="0" stopColor="#871101"></stop>
        <stop offset=".99" stopColor="#911209"></stop>
        <stop offset="1" stopColor="#911209"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-b)"
        d="M117.488 117.93l-7.649-52.799-20.837 27.514z"
      ></path>
      <linearGradient
        id="ruby-original-c"
        gradientUnits="userSpaceOnUse"
        x1="143.542"
        y1="2380.69"
        x2="110.81"
        y2="2402.655"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#871101"></stop>
        <stop offset="0" stopColor="#871101"></stop>
        <stop offset=".99" stopColor="#911209"></stop>
        <stop offset="1" stopColor="#911209"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-c)"
        d="M117.592 117.93l-56.044-4.399-32.91 10.385z"
      ></path>
      <linearGradient
        id="ruby-original-d"
        gradientUnits="userSpaceOnUse"
        x1="74.817"
        y1="2435.622"
        x2="79.891"
        y2="2402.644"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset=".23" stopColor="#E57252"></stop>
        <stop offset=".46" stopColor="#DE3B20"></stop>
        <stop offset=".99" stopColor="#A60003"></stop>
        <stop offset="1" stopColor="#A60003"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-d)"
        d="M28.717 123.928l14.001-45.867-30.81 6.588z"
      ></path>
      <linearGradient
        id="ruby-original-e"
        gradientUnits="userSpaceOnUse"
        x1="109.719"
        y1="2466.413"
        x2="111.589"
        y2="2432.757"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset=".23" stopColor="#E4714E"></stop>
        <stop offset=".56" stopColor="#BE1A0D"></stop>
        <stop offset=".99" stopColor="#A80D00"></stop>
        <stop offset="1" stopColor="#A80D00"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-e)"
        d="M88.996 92.797l-12.882-50.46-36.866 34.558z"
      ></path>
      <linearGradient
        id="ruby-original-f"
        gradientUnits="userSpaceOnUse"
        x1="140.691"
        y1="2497.523"
        x2="146.289"
        y2="2473.401"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset=".18" stopColor="#E46342"></stop>
        <stop offset=".4" stopColor="#C82410"></stop>
        <stop offset=".99" stopColor="#A80D00"></stop>
        <stop offset="1" stopColor="#A80D00"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-f)"
        d="M121.275 43.047L86.426 14.585l-9.704 31.373z"
      ></path>
      <linearGradient
        id="ruby-original-g"
        gradientUnits="userSpaceOnUse"
        x1="123.6"
        y1="2506.018"
        x2="147.719"
        y2="2518.077"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset=".54" stopColor="#C81F11"></stop>
        <stop offset=".99" stopColor="#BF0905"></stop>
        <stop offset="1" stopColor="#BF0905"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-g)"
        d="M104.978 4.437L84.481 15.764 71.551 4.285z"
      ></path>
      <linearGradient
        id="ruby-original-h"
        gradientUnits="userSpaceOnUse"
        x1="53.674"
        y1="2444.028"
        x2="55.66"
        y2="2424.153"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset="0" stopColor="#fff"></stop>
        <stop offset=".31" stopColor="#DE4024"></stop>
        <stop offset=".99" stopColor="#BF190B"></stop>
        <stop offset="1" stopColor="#BF190B"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-h)"
        d="M3.802 100.034l8.586-15.659L5.442 65.72z"
      ></path>
      <path
        fill="#fff"
        d="M4.981 65.131l6.987 19.821 30.365-6.812L77 45.922l9.783-31.075L71.38 3.969l-26.19 9.802c-8.252 7.675-24.263 22.86-24.84 23.146-.573.291-10.575 19.195-15.369 28.214z"
      ></path>
      <linearGradient
        id="ruby-original-i"
        gradientUnits="userSpaceOnUse"
        x1="40.026"
        y1="2418.781"
        x2="133.345"
        y2="2514.739"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#BD0012"></stop>
        <stop offset="0" stopColor="#BD0012"></stop>
        <stop offset=".07" stopColor="#fff"></stop>
        <stop offset=".17" stopColor="#fff"></stop>
        <stop offset=".27" stopColor="#C82F1C"></stop>
        <stop offset=".33" stopColor="#820C01"></stop>
        <stop offset=".46" stopColor="#A31601"></stop>
        <stop offset=".72" stopColor="#B31301"></stop>
        <stop offset=".99" stopColor="#E82609"></stop>
        <stop offset="1" stopColor="#E82609"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-i)"
        d="M29.519 29.521c17.882-17.73 40.937-28.207 49.785-19.28 8.843 8.926-.534 30.62-18.418 48.345-17.884 17.725-40.653 28.779-49.493 19.852-8.849-8.92.242-31.191 18.126-48.917z"
      ></path>
      <linearGradient
        id="ruby-original-j"
        gradientUnits="userSpaceOnUse"
        x1="111.507"
        y1="2409.102"
        x2="83.398"
        y2="2416.039"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#8C0C01"></stop>
        <stop offset="0" stopColor="#8C0C01"></stop>
        <stop offset=".54" stopColor="#990C00"></stop>
        <stop offset=".99" stopColor="#A80D0E"></stop>
        <stop offset="1" stopColor="#A80D0E"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-j)"
        d="M28.717 123.909l13.89-46.012 46.135 14.82c-16.68 15.642-35.233 28.865-60.025 31.192z"
      ></path>
      <linearGradient
        id="ruby-original-k"
        gradientUnits="userSpaceOnUse"
        x1="159.785"
        y1="2442.837"
        x2="134.814"
        y2="2465.217"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#7E110B"></stop>
        <stop offset="0" stopColor="#7E110B"></stop>
        <stop offset=".99" stopColor="#9E0C00"></stop>
        <stop offset="1" stopColor="#9E0C00"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-k)"
        d="M77.062 45.831l11.844 46.911c13.934-14.65 26.439-30.401 32.563-49.883l-44.407 2.972z"
      ></path>
      <linearGradient
        id="ruby-original-l"
        gradientUnits="userSpaceOnUse"
        x1="168.959"
        y1="2483.901"
        x2="156.521"
        y2="2497.199"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#79130D"></stop>
        <stop offset="0" stopColor="#79130D"></stop>
        <stop offset=".99" stopColor="#9E120B"></stop>
        <stop offset="1" stopColor="#9E120B"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-l)"
        d="M121.348 43.097c4.74-14.305 5.833-34.825-16.517-38.635l-18.339 10.13 34.856 28.505z"
      ></path>
      <path
        fill="#9E1209"
        d="M3.802 99.828c.656 23.608 17.689 23.959 24.945 24.167l-16.759-39.14-8.186 14.973z"
      ></path>
      <radialGradient
        id="ruby-original-m"
        cx="138.703"
        cy="2464.789"
        r="30.601"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#A80D00"></stop>
        <stop offset="0" stopColor="#A80D00"></stop>
        <stop offset=".99" stopColor="#7E0E08"></stop>
        <stop offset="1" stopColor="#7E0E08"></stop>
      </radialGradient>
      <path
        fill="url(#ruby-original-m)"
        d="M77.128 45.904c10.708 6.581 32.286 19.798 32.723 20.041.68.383 9.304-14.542 11.261-22.976l-43.984 2.935z"
      ></path>
      <radialGradient
        id="ruby-original-n"
        cx="96.325"
        cy="2424.465"
        r="40.679"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#A30C00"></stop>
        <stop offset="0" stopColor="#A30C00"></stop>
        <stop offset=".99" stopColor="#800E08"></stop>
        <stop offset="1" stopColor="#800E08"></stop>
      </radialGradient>
      <path
        fill="url(#ruby-original-n)"
        d="M42.589 77.897l18.57 35.828c10.98-5.955 19.579-13.211 27.454-20.983L42.589 77.897z"
      ></path>
      <linearGradient
        id="ruby-original-o"
        gradientUnits="userSpaceOnUse"
        x1="67.509"
        y1="2393.115"
        x2="57.373"
        y2="2427.506"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#8B2114"></stop>
        <stop offset="0" stopColor="#8B2114"></stop>
        <stop offset=".43" stopColor="#9E100A"></stop>
        <stop offset=".99" stopColor="#B3100C"></stop>
        <stop offset="1" stopColor="#B3100C"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-o)"
        d="M11.914 84.904l-2.631 31.331c4.964 6.781 11.794 7.371 18.96 6.842-5.184-12.9-15.538-38.696-16.329-38.173z"
      ></path>
      <linearGradient
        id="ruby-original-p"
        gradientUnits="userSpaceOnUse"
        x1="145.272"
        y1="2507.076"
        x2="167.996"
        y2="2497.045"
        gradientTransform="matrix(1 0 0 -1 -47.5 2517)"
      >
        <stop offset="0" stopColor="#B31000"></stop>
        <stop offset="0" stopColor="#B31000"></stop>
        <stop offset=".44" stopColor="#910F08"></stop>
        <stop offset=".99" stopColor="#791C12"></stop>
        <stop offset="1" stopColor="#791C12"></stop>
      </linearGradient>
      <path
        fill="url(#ruby-original-p)"
        d="M86.384 14.67l36.891 5.177c-1.969-8.343-8.015-13.727-18.32-15.41L86.384 14.67z"
      ></path>
    </svg>
  )
};
